import React, { useState, useEffect } from 'react';

// Import the Instagram and TikTok icon images from the assets folder
import instagramIcon from './assets/instagram.png';
import tiktokIcon from './assets/tiktok.png';
// Import the logo image from the assets folder
import logo from './assets/logo.png';

const App = () => {
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const styleSheet = document.styleSheets[0];

    const fadeInZoomKeyframes = `
      @keyframes fadeInZoom {
        0% {
          opacity: 0;
          transform: scale(0.8);
        }
        100% {
          opacity: 1;
          transform: scale(1);
        }
      }
    `;

    // Add keyframes to the document's stylesheet
    if (styleSheet) {
      styleSheet.insertRule(fadeInZoomKeyframes, styleSheet.cssRules.length);
    }
  }, []);

  const headerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 0',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #ddd',
    position: 'fixed',
    top: 0,
    width: '100%',
    zIndex: 1000,
    textAlign: 'center',
  };

  const linkContainerStyle = {
    display: 'flex',
    justifyContent: 'center',  // Center the link container
    alignItems: 'center',
    gap: '20px',
    flexWrap: 'wrap',  // Allow links to wrap on smaller screens
  };

  const iconStyle = (type) => ({
    width: '50px',
    height: '70px',
    transition: 'transform 0.3s ease',
    transform: hovered === type ? 'scale(1.3)' : 'scale(1)',
  });

  const linkStyle = {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: '#000',
    fontSize: '16px',
    transition: 'color 0.3s, text-shadow 0.3s',
  };

  const textStyle = (type) => ({
    textDecoration: 'underline',
    color: hovered === type ? '#007bff' : '#000',
    textShadow: hovered === type ? '1px 1px 2px rgba(0, 0, 0, 0.3)' : 'none',
    transition: 'color 0.3s, text-shadow 0.3s',
  });

  const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center items horizontally
    textAlign: 'center',
    padding: '100px 20px 50px 20px',
  };

  const logoStyle = {
    width: '350px',
    height: 'auto',
    margin: '40px 0 20px 0',
    animation: 'fadeInZoom 1s ease-in-out',
  };

  const testimonialSectionStyle = {
    padding: '50px 20px',
    textAlign: 'center',
  };

  const testimonialCardStyle = {
    backgroundColor: '#fff',
    margin: '20px auto',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    animation: 'fadeInZoom 1s ease-in-out',
  };

  const buttonStyle = (type) => ({
    display: 'block',
    width: '300px',
    padding: '20px',
    margin: '10px auto',
    border: '2px solid',
    borderColor: hovered === type ? 'black' : '#000',
    borderRadius: '5px',
    backgroundColor: hovered === type ? '#e0e0e0' : '#fff',
    color: '#000',
    fontSize: '20px',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    transition: 'background-color 0.3s, color 0.3s, border-color 0.3s, transform 0.3s',
    transform: hovered === type ? 'scale(1.1)' : 'scale(1)',
  });

  const footerStyle = {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #ddd',
    position: 'static',
    width: '100%',
  };

  return (
    <div>
      <header style={headerStyle}>
        <div style={linkContainerStyle}>
          <a
            href="https://www.instagram.com/prismcreationsuk/"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseEnter={() => setHovered('instagram')}
            onMouseLeave={() => setHovered(null)}
          >
            <img src={instagramIcon} alt="Instagram" style={iconStyle('instagram')} />
            <span style={textStyle('instagram')}>Instagram</span>
          </a>
          <a
            href="https://www.tiktok.com/@prismcreationsuk"
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseEnter={() => setHovered('tiktok')}
            onMouseLeave={() => setHovered(null)}
          >
            <img src={tiktokIcon} alt="TikTok" style={iconStyle('tiktok')} />
            <span style={textStyle('tiktok')}>TikTok</span>
          </a>
        </div>
      </header>

      <main style={bodyStyle}>
        <img src={logo} alt="Main Logo" style={logoStyle} />
        <a
          href="https://www.etsy.com/shop/prismcreationsUK"
          target="_blank"
          rel="noopener noreferrer"
          style={buttonStyle('button1')}
          onMouseEnter={() => setHovered('button1')}
          onMouseLeave={() => setHovered(null)}
        >
          <div>Visit Us on Etsy!</div>
        </a>

        <a
          href="https://www.paypal.com/paypalme/prismcreations"
          target="_blank"
          rel="noopener noreferrer"
          style={buttonStyle('button2')}
          onMouseEnter={() => setHovered('button2')}
          onMouseLeave={() => setHovered(null)}
        >
          <div>Pay Us through PayPal</div>
        </a>
      </main>

      <section style={testimonialSectionStyle}>
        <h2>What Our Customers Say</h2>
        <div style={testimonialCardStyle}>
          <p>"I was delighted with this card. It is absolutely beautiful. I have no hesitation in recommending Prism Creations. Thank you very much."</p>
        </div>
        <div style={testimonialCardStyle}>
          <p>"Excellent service from the seller would use them again I was very surprised at the speed with which it came very pleased."</p>
        </div>
        <div style={testimonialCardStyle}>
          <p>"Order arrived promptly in excellent condition just as described. Have ordered before from this company and would recommend."</p>
        </div>
      </section>

      <footer style={footerStyle}>
        Thank you for supporting our small business!
      </footer>
    </div>
  );
};

export default App;
